import React, { useState } from 'react';
import { useFormik } from 'formik';
import TextField from '@mui/material/TextField';
import ReactLoading from 'react-loading';
import { GiveCodeSchema } from '../schemas';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/resetPassword.css';

const GiveCode = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [formMessage, setFormMessage] = useState({ type: '', text: '' });
    const navigate = useNavigate();
    const { state } = useLocation();

    const onSubmit = () => {
        setIsLoading(true);
        setFormMessage({ type: '', text: '' });
        if (state && values.code == state.code) {
            setFormMessage({ type: 'success', text: 'Code verified successfully!' });
            setTimeout(() => {
                setIsLoading(false);
                navigate('/reset-password', { state: { email: state.email } });
            }, 2000);
        } else {
            setFormMessage({ type: 'error', text: 'Incorrect code. Please try again.' });
            setIsLoading(false);
        }
    };

    const { values, errors, handleBlur, touched, handleChange, handleSubmit } = useFormik({
        initialValues: {
            code: '',
        },
        validationSchema: GiveCodeSchema,
        onSubmit
    });

    return (
        <div className='reset-password-container'>
            <div className="reset-password-wrapper">
                <div className="reset-password-header">
                    <h1>Enter Verification Code</h1>
                    <p>A verification code has been sent to your email.</p>
                </div>

                <form method="POST" className='reset-password-form' onSubmit={handleSubmit}>
                    {formMessage.text && (
                        <div className={`form-message ${formMessage.type}`}>
                            {formMessage.text}
                        </div>
                    )}
                    <div className='form-group'>
                        <label htmlFor="code">Verification Code</label>
                        <TextField
                            fullWidth
                            required
                            error={!!(errors.code && touched.code)}
                            id="code"
                            variant="outlined"
                            name='code'
                            value={values.code}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="form-control"
                            placeholder="Enter the 6-digit code"
                        />
                        {errors.code && touched.code && <p className='error-text'>{errors.code}</p>}
                    </div>


                    <button className="reset-password-btn" type="submit" disabled={isLoading}>
                        {isLoading ? <ReactLoading type="spin" color="#fff" height={25} width={25} /> : "Verify Code"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default GiveCode;